<template>
  <header class="header" :class="{ 'is-open-search' : isOpenSearch }">
    <div class="header__container">
      <div class="header__body">
        <div class="header__logo-wrap">
          <Logo class="header__logo" />
        </div>

        <div class="header__search">
          <SearchModal :is-open="isOpenSearch" @open="openSearch" @close="closeSearch" />
        </div>

        <div class="header__nav-right-wrapper">
          <div class="header__nav-right">
            <HeaderRight
              v-onmount="() => isMountedMainComponent = true"
              class="header__right"
              :class="{ 'show': true }"
            />
            <UiBtn
              v-show="isLoggedIn"
              prefetch
              :size="{ default: 's', 'mobile-md': 'm', 'tablet-album': 'l' }"
              class="header__btn-wallet"
              color="primary"
              data-id="header-cashbox-link"
              :data-gtm-id="GA_HEADER_CLICK_BTN_CASHBOX"
              rel="nofollow"
              icon="cashbox/plus"
              @click="toCashbox"
            >
              <UiText class="header__btn-wallet-text" :text="$tc('buttons.payin')" />
            </UiBtn>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ClickOutside from 'vue-click-outside'
import { storageService } from '@/services'
import { GTM_CASHBOX } from '@/constants/gtm'

/** Components */
import Logo from '@/components/Base/Logo'

export default {
  name: 'AppHeaderFull',
  components: {
    Logo,
    HeaderRight: () => import(/* webpackChunkName: "header-c" */ '@/components/App/AppHeader/HeaderRight'),
    SearchModal: () => import(/* webpackChunkName: "header-c" */ '@/components/Lobby/SearchModal'),
  },
  directives: { ClickOutside },
  data() {
    return {
      GA_HEADER_CLICK_BTN_CASHBOX: GTM_CASHBOX.ID.ga_header_click_btn_cashbox,
    }
  },
  computed: {
    ...mapGetters('user', ['user', 'isLoggedIn', 'profileInfoLoading', 'isUserLoaded', 'isUserVerified']),
    ...mapGetters('base', ['isServerToken']),
    ...mapGetters('lobby', ['isOpenSearch']),
  },
  watch: {
    isLoggedIn() {
      setTimeout(() => {
        this.checkPromocode()
      }, 400)
    },
  },
  mounted() {
    this.checkPromocode()
  },
  methods: {
    ...mapActions('lobby', ['toggle_openSearch']),
    ...mapActions('base', ['closeDropdown']),
    ...mapActions('globalModal', ['open_globalModalVerifyBeforePay']),
    toCashbox() {
      this.$router.push(this.$paths.cashbox)
    },
    checkPromocode() {
      if (this.isLoggedIn && !!storageService.getItem('promoCode') && !this.$route.query.bigModal) {
        this.$store.dispatch('globalModal/open_globalModalPromocode')
      }
      else if (!this.isLoggedIn && !!storageService.getItem('promoCode') && !this.$route.query.bigModal) {
        this.$newModal.openAuthOrRegister()
      }
    },
    openSearch() {
      this.toggle_openSearch(true)
      this.closeDropdown()
    },
    closeSearch() {
      this.toggle_openSearch(false)
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
